import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/index/search.svg'


const _withScopeId = n => (_pushScopeId("data-v-62fdf37e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon icon-right",
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "pull-box" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "dcEmpty" }

import { ref, onMounted, watch, computed } from 'vue'
import type { SelectProps } from 'ant-design-vue'
import { useRouter, useRoute } from 'vue-router'
import { allSearch, allSearchLbu, allSearchOFbu } from '@/api/gucangSales/businessRuleSetting'
import { debounce } from 'lodash-es'
import { ROUTERGO, ROUTERType } from './hooks/enum'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'CusSelect' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: String || Array
  },
  type: {
    type: String,
    default: 'cos_fbu' // cos_fbu、cos_ofbu、cos_lbu
  }
},
  emits: ['update:value', 'selectData'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
/// 默认客户代码
const searchType = ref<number>(3)
const props = __props
const spinning = ref(false)
const pageNumber = ref(1)
const data = ref()
const searchTxt = ref('')
const emit = __emit
const optionPage = ref<any[]>([])
// 提示语
const placeholderSearch = computed(() => (props.type === 'cos_ofbu' ? t('home.wguiy6') : t('home.wguiy5')))
// 赋值
watch(
  () => props.value,
  (v, prev) => {
    if (v && v !== data.value) {
      data.value = v
    } else if (!v) {
      data.value = undefined
    }
  },
  { immediate: true }
)
const statusEnum: any = {
  0: t('home.a27bas'),
  1: t('home.inoqrl'),
  2: t('home.ne9mdc'),
  3: t('home.pmre4f'),
  5: t('home.a27bas'),
  8: t('home.vov0jp'),
  10: t('home.2e24jh'),
  11: t('home.p5d8cm'),
  12: t('home.ni1e64'),
  13: t('home.wsdvme'),
  14: t('home.prwoss'),
  20: t('home.ahwj9u'),
  21: t('home.6twq14'),
  22: t('home.pwdrhz'),
  30: t('home.52d61f'),
  31: t('home.cxtphk'),
  32: t('home.0q8guc'),
  33: t('home.a1294c'),
  34: t('home.nfdaeq'),
  35: t('home.8g8lg9'),
  36: t('home.9d6v9g'),
  37: t('home.sda243'),
  38: t('home.jgh53d'),
  39: t('home.34hbm6')
}
const pageType = ref<string>()
const inputSearch = ref()
const openPopup = ref(true)
watch(
  () => props.type,
  () => {
    pageType.value = props.type
  },
  { immediate: true }
)
const change: SelectProps['onChange'] = (value) => {
  const itemData = optionPage.value.filter((item) => item.cosId === value)
  if (!itemData[0].hasPermission) {
    return
  }
  if (optionPage.value) {
    const arr = optionPage.value.filter((item) => item.cosId === value)
    emit('selectData', arr[0] ? arr[0].arkCode : '')
    if (arr.length > 0 && pageType.value && ['cos_fbu', 'cos_ofbu'].includes(pageType.value)) {
      const query = {
        cosId: arr[0].cosId,
        returnPath: route.fullPath
      }

      if (arr[0].publicStatus === 1) {
        query.isPublicClue = 1
      }
      switch (arr[0].stage) {
        case ROUTERType.FBUPOTENTIALType:
          router.push({
            path: pageType.value === 'cos_fbu' ? `${ROUTERGO.FBUPOTENTIAL}` : `${ROUTERGO.OFBUPOTENTIAL}`,
            query: query
          })
          break
        case ROUTERType.FBUSIGNType:
          router.push({
            path: pageType.value === 'cos_fbu' ? `${ROUTERGO.FBUSIGN}` : `${ROUTERGO.OFBUSIGN}`,
            query: query
          })

          break
        case ROUTERType.FBUSUCCESSType:
          router.push({
            path: pageType.value === 'cos_fbu' ? `${ROUTERGO.FBUSUCCESS}` : `${ROUTERGO.OFBUSUCCESS}`,
            query: query
          })
          break
        case ROUTERType.FBUCLUESType:
          if (arr[0].status === 0) {
            router.push({
              path: pageType.value === 'cos_fbu' ? `${ROUTERGO.FBUCLUES}` : `${ROUTERGO.OFBUCLUES}`,
              query: {
                clueId: arr[0].cosId,
                returnPath: route.fullPath,
                isPublicClue: 1
              }
            })
          } else {
            router.push({
              path: pageType.value === 'cos_fbu' ? `${ROUTERGO.FBUCLUES}` : `${ROUTERGO.OFBUCLUES}`,
              query: {
                clueId: arr[0].cosId,
                returnPath: route.fullPath
              }
            })
          }

          break
      }
    }
    if (arr.length > 0 && pageType.value === 'cos_lbu') {
      switch (arr[0].stage) {
        case ROUTERType.LBUPOTENTIALType:
          router.push({
            path: `${ROUTERGO.LBUPOTENTIAL}`,
            query: {
              cosId: arr[0].cosId,
              returnPath: route.fullPath
            }
          })
          break
        case ROUTERType.LBUSUCCESSType:
          router.push({
            path: `${ROUTERGO.LBUSUCCESS}`,
            query: {
              cosId: arr[0].cosId,
              returnPath: route.fullPath
            }
          })
          break
        case ROUTERType.LBUCLUESType:
          if (arr[0].status === 0) {
            router.push({
              path: `${ROUTERGO.LBUCLUES}`,
              query: {
                clueId: arr[0].cosId,
                returnPath: route.fullPath,
                isPublicClue: 1
              }
            })
          } else {
            router.push({
              path: `${ROUTERGO.LBUCLUES}`,
              query: {
                clueId: arr[0].cosId,
                returnPath: route.fullPath
              }
            })
          }
          break
      }
    }
  }
  emit('update:value', value)
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const handleEnter = () => {
  if (data.value === -9) {
    data.value = ''
  }
}
const search = debounce(async (txt: string) => {
  searchTxt.value = txt
  optionPage.value = []
  pageNumber.value = 1
  setTimeout(() => {
    fetch()
  })
}, 500)
const onFocus = (onFocus: boolean) => {
  openPopup.value = onFocus
}
const handleSearchTypeChange = (value?: any) => {
  optionPage.value = []
  if (searchTxt.value) {
    inputSearch.value?.focus()
    openPopup.value = true
    search(searchTxt.value)
  }
}
// 获取公司下拉列表
const fetch = () => {
  if (!searchTxt.value.trim()) {
    return
  }
  spinning.value = true
  if (pageType.value === 'cos_lbu') {
    allSearchLbu({
      searchType: searchType.value,
      searchText: searchTxt.value.trim(),
      pageNumber: pageNumber.value,
      pageSize: 10
    }).then((res) => {
      spinning.value = false
      if (res.data.items.length > 0) {
        res.data.items.forEach((element: any) => {
          element.value = element.cosId
        })
      }
      const isNull = optionPage.value[0]?.value === -9
      if (!isNull) {
        if (pageNumber.value === 1) {
          optionPage.value = res.data.items
        } else {
          optionPage.value = [...optionPage.value, ...res.data.items]
        }
      } else if (res.data.items.length > 0) {
        optionPage.value = res.data.items
      }
      if (res.data.items.length === 0 && pageNumber.value === 1) {
        optionPage.value = [{ value: -9, label: '暂无数据' }]
      }
    })
  } else if (pageType.value === 'cos_fbu') {
    allSearch({
      searchType: searchType.value,
      searchText: searchTxt.value.trim(),
      pageNumber: pageNumber.value,
      pageSize: 10
    }).then((res) => {
      spinning.value = false
      if (res.data.items.length > 0) {
        res.data.items.forEach((element: any) => {
          element.value = element.cosId
        })
      }
      const isNull = optionPage.value[0]?.value === -9
      if (!isNull) {
        if (pageNumber.value === 1) {
          optionPage.value = res.data.items
        } else {
          optionPage.value = [...optionPage.value, ...res.data.items]
        }
      } else if (res.data.items.length > 0) {
        optionPage.value = res.data.items
      }
      if (res.data.items.length === 0 && pageNumber.value === 1) {
        optionPage.value = [{ value: -9, label: '暂无数据' }]
      }
    })
  } else {
    allSearchOFbu({
      searchType: searchType.value,
      searchText: searchTxt.value.trim(),
      pageNumber: pageNumber.value,
      pageSize: 10
    }).then((res) => {
      spinning.value = false
      if (res.data.items.length > 0) {
        res.data.items.forEach((element: any) => {
          element.value = element.cosId
        })
      }
      const isNull = optionPage.value[0]?.value === -9
      if (!isNull) {
        if (pageNumber.value === 1) {
          optionPage.value = res.data.items
        } else {
          optionPage.value = [...optionPage.value, ...res.data.items]
        }
      } else if (res.data.items.length > 0) {
        optionPage.value = res.data.items
      }
      if (res.data.items.length === 0 && pageNumber.value === 1) {
        optionPage.value = [{ value: -9, label: '暂无数据' }]
      }
    })
  }
}

onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_DcPenetrateContent = _resolveComponent("DcPenetrateContent")!
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_unref(t)('home.k04rdq')), 1),
    _createVNode(_component_a_spin, {
      spinning: spinning.value,
      delay: 200
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input_group, {
          compact: "",
          class: "input"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: searchType.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchType).value = $event)),
              style: {"width":"33%"},
              onChange: handleSearchTypeChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('home.kgf93s')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: 2 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('home.rqp3ld')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: 3 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('home.ps4h0r')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: 4 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('home.8nyeeu')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: 5 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('home.hfm7qa')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: 6 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('home.ds23sf')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            _createVNode(_component_a_auto_complete, {
              placeholder: _unref(t)('home.sri2s2'),
              value: data.value,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((data).value = $event)),
              style: {"width":"67%"},
              ref_key: "inputSearch",
              ref: inputSearch,
              onPopupScroll: popupScroll,
              showSearch: true,
              "filter-option": false,
              onSearch: _unref(search),
              allowClear: "",
              dropdownMatchSelectWidth: false,
              options: optionPage.value,
              onSelect: change,
              open: openPopup.value,
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (onFocus(false))),
              onFocus: _cache[5] || (_cache[5] = ($event: any) => (onFocus(true))),
              onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (handleEnter()), ["enter"]))
            }, {
              suffixIcon: _withCtx(() => [
                _hoisted_2
              ]),
              option: _withCtx((item) => [
                (item.value !== -9)
                  ? (_openBlock(), _createBlock(_component_DcPenetrateContent, {
                      key: 0,
                      style: {"background-color":"transparent"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("p", null, " 【" + _toDisplayString([_unref(t)('home.ezjlnj'), _unref(t)('home.8ho89e'), _unref(t)(props.type === 'cos_ofbu' ?  'home.jdn2ws' : 'home.jdn2we'), _unref(t)('home.z415qj')][item.stage - 1]) + "(" + _toDisplayString(['cos_fbu', 'cos_ofbu'].includes(props.type) && item.stage === 1 && item.clueType != null
                      ? item.status === 0
                        ? _unref(t)('home.a27bas')
                        : [_unref(t)('home.vevwzm'), _unref(t)('home.hwu5bv'), _unref(t)('home.u7gauo'), _unref(t)('home.ti9eob')][item.clueType]
                      : props.type === 'cos_fbu' && item.stage > 1 && item.publicStatus === 1
                      ? _unref(t)('home.g4h42g')
                      : statusEnum[item.status]) + ")】" + _toDisplayString(_unref(t)('home.rqp3ld')) + "：" + _toDisplayString(item.customerName || '--') + " " + _toDisplayString(_unref(t)('home.ps4h0r')) + "：" + _toDisplayString(item.arkCode || item.customerSerial || '--'), 1),
                          (props.type === 'cos_ofbu')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)('home.8nyeeu')) + "：" + _toDisplayString(item.mobile || '--') + " " + _toDisplayString(_unref(t)('home.hfm7qa')) + "：" + _toDisplayString(item.email || '--') + " " + _toDisplayString(_unref(t)('home.9sns5l')) + "：" + _toDisplayString(item.sellerName || '--'), 1))
                            : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(t)('home.oez6lt')) + "：" + _toDisplayString(item.tel || '--') + " " + _toDisplayString(_unref(t)('home.8nyeeu')) + "：" + _toDisplayString(item.mobile || '--') + " " + _toDisplayString(_unref(t)('home.hfm7qa')) + "：" + _toDisplayString(item.email || '--') + " " + _toDisplayString(_unref(t)('home.9sns5l')) + "：" + _toDisplayString(item.sellerName || '--'), 1))
                        ]),
                        (!item.hasPermission)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["empit-box", !item.hasPermission ? 'isDisable' : '']),
                              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                            }, null, 2))
                          : _createCommentVNode("", true),
                        (item.hasPermission)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["empit-box", !item.hasPermission ? 'isDisable' : ''])
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (item.value === -9)
                  ? (_openBlock(), _createBlock(_component_DcPenetrateContent, {
                      key: 1,
                      style: {"background-color":"transparent"},
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_dc_layout_empty, {
                            type: "nothing",
                            style: { width: '191px' }
                          })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["placeholder", "value", "onSearch", "options", "open"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}
}

})